var $2c9039f4a2d8ea02$exports = {};
$2c9039f4a2d8ea02$exports = {
    "endTime": `L\xf5puaeg`,
    "startTime": `Algusaeg`,
    "time": `Aeg`
};


export {$2c9039f4a2d8ea02$exports as default};
//# sourceMappingURL=et-EE.module.js.map
